export default {

  data() {
    return {}
  },

  created() {
  },

  methods: {
    onFormStepNext() {
      this.$emit("step-changed", this.current + 1);
    },
    onFormStepPrev() {
      this.$emit("step-changed", this.current - 1);
    },
    onFormSubmit() {
      this.$emit("submit");
    }
  }
}
